import { Dispatch } from 'redux';

import * as Actions from '../actions/exerciseForm';
import { IUserAttr } from '../actions/session';
import AbstractScenario from './AbstractScenario';

/** 課題情報取得シナリオ用パラメータ */
export interface IFetchExerciseStatusParam {
	careerID: string;
	classID: string;
	seq: string;
	userAttr: IUserAttr;
	isPreview: boolean;
}

/** 提出ファイル削除シナリオ用パラメータ */
export interface IDeleteExerciseFileParam {
	careerID: string;
	classID: string;
	seq: string;
	userAttr: IUserAttr;
	isPreview: boolean;
}

/**
 * 課題シナリオファクトリ
 */
export default class ExerciseFormScenarioFactory {
	/**
	 * 課題情報取得シナリオ作成
	 */
	public static createFetchExerciseStatus(dispatch: Dispatch, token: string) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<
			IFetchExerciseStatusParam
		> {
			protected process(arg: IFetchExerciseStatusParam) {
				const param = {
					accessType: arg.isPreview ? 21 : 10,
					careerID: arg.careerID,
					classID: arg.classID,
					seq: arg.seq,
					userId: arg.userAttr.userId,
					viewMode: arg.isPreview ? 1 : 0,
				};
				return this.read(
					'el_el_ELearningReportSearchConditionModel',
					param
				).then(data => {
					const reportName: string = data.reportName;
					const reportTemplateFileName: string =
						data.reportTemplateFileName;
					const submittedReportFile: string =
						data.submittedReportFile;
					const resultStatus: number = data.resultStatus;
					const displayDownloadButton: boolean =
						data.displayButtonList.displayDownloadButton;
					const displayUploadButton: boolean =
						data.displayButtonList.displayUploadButton;
					const displaySubmittedReportDownloadButton: boolean =
						data.displayButtonList
							.displaySubmittedReportDownloadButton;
					const displayDeleteButton: boolean =
						data.displayButtonList.displayDeleteButton;
					this.dispatch(
						Actions.setExerciseFormParams({
							displayDeleteButton,
							displayDownloadButton,
							displaySubmittedReportDownloadButton,
							displayUploadButton,
							reportName,
							reportTemplateFileName,
							resultStatus,
							submittedReportFile,
						})
					);
				});
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * 提出ファイル削除シナリオ作成
	 * @param dispatch ディスパッチャ
	 * @param token Web APIトークン
	 */
	public static createDeleteExerciseFile(dispatch: Dispatch, token: string) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<
			IDeleteExerciseFileParam
		> {
			protected process(arg: IDeleteExerciseFileParam) {
				const param = {
					accessType: arg.isPreview ? 21 : 10,
					careerID: arg.careerID,
					classID: arg.classID,
					id: 'delete',
					seq: arg.seq,
					userId: arg.userAttr.userId,
					viewMode: arg.isPreview ? 1 : 0,
				};
				return this.delete(
					'el_el_ELearningReportSearchConditionModel',
					param
				).then(data => {
					const s = ExerciseFormScenarioFactory.createFetchExerciseStatus(
						dispatch,
						token
					);
					s.run({
						careerID: arg.careerID,
						classID: arg.classID,
						isPreview: arg.isPreview,
						seq: arg.seq,
						userAttr: arg.userAttr,
					});
				});
			}
		}(dispatch, token);
		return scenario;
	}
}



// WEBPACK FOOTER //
// ./src/scenario/ExerciseFormScenarioFactory.ts